<template>
  <ElDialog
      v-model="isShow"
      :title="$t('tips')"
      :footer="null"
      centered
      :width="400"
      destroyOnClose
      @cancel="close"
      :class="[isHeadLine ? 'headline' : 'noheadline']"
  >
    <div>
      <span>{{ $t('common.team.child.txt') }}</span>
      <span style="font-weight: 600">{{ $t('common.team.target.txt') }}</span>
      <span>{{ $t('common.team.child.txt.end') }}</span>
    </div>
    <template #footer>
      <div class="setting_center">
        <el-button size="small" @click="close">{{ $t('common.sss16') }}</el-button>
        <el-button size="small" type="primary" @click="handleClickTo">
          {{
            $t('common.team.child.add')
          }}
        </el-button>
      </div>
    </template>
  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits} from 'vue'
import {useStore} from "vuex";
import {deleteGroupFile} from "@/api/sidebar";
import {useRouter} from "vue-router";

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const fileDirName = ref("")
const loading = ref(false)
const router = useRouter()

const {value, isHeadLine, currentItem} = defineProps({
  value: {type: Boolean, default: false},
  isHeadLine: {type: Boolean, default: false},
  currentItem: {type: Object, default: {}}
})

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})
const close = () => {
  emit("close");
}

const handleClickTo = () => {
  router.push("/email/group_setting")
}
</script>
<style lang="less" scoped>
.fx-j-c {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.title_cdir {
  color: rgba(0, 0, 0, .85);
  font-weight: 700;
  font-size: 14px;
}

.fx-j-r {
  display: flex;
  justify-content: right;
  margin-top: 40px;
}

.inners_warning {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
